import {
  ACCOUNT_ID_COLUMN_MIN_WIDTH,
  AUTOPAY_COLUMN_MIN_WIDTH,
  CONTACT_INFO_COLUMN_MIN_WIDTH,
  CUSTOMER_COLUMN_MIN_WIDTH,
  INVOICES_COLUMN_MIN_WIDTH,
  OUTSTANDING_COLUMN_MIN_WIDTH,
  PAYMENT_METHOD_COLUMN_MIN_WIDTH,
  PAYMENT_PLAN_COLUMN_MIN_WIDTH,
  STATEMENT_COLUMN_MIN_WIDTH,
} from '@finance-hub/domain/customers/components/customers-table-constants';
import { CustomerSortField } from '@finance-hub/domain/customers/blocs/types/customer-list';

interface CustomersTableColumn {
  id: string;
  initialPercentWidth: number;
  labelKey: string;
  minSize: number;
  sortField: CustomerSortField;
}

export const CUSTOMERS_TABLE_COLUMNS: CustomersTableColumn[] = [
  {
    id: 'customerName',
    initialPercentWidth: 27,
    labelKey: 'finance_hub.customers.table.column.customer',
    minSize: CUSTOMER_COLUMN_MIN_WIDTH,
    sortField: 'customerName',
  },
  {
    id: 'accountId',
    initialPercentWidth: 9,
    labelKey: 'finance_hub.customers.table.column.account_id',
    minSize: ACCOUNT_ID_COLUMN_MIN_WIDTH,
    sortField: 'accountId',
  },
  {
    id: 'outstanding',
    initialPercentWidth: 11,
    labelKey: 'finance_hub.customers.table.column.outstanding',
    minSize: OUTSTANDING_COLUMN_MIN_WIDTH,
    sortField: 'outstanding',
  },
  {
    id: 'invoiceCount',
    initialPercentWidth: 7,
    labelKey: 'finance_hub.customers.table.column.invoices',
    minSize: INVOICES_COLUMN_MIN_WIDTH,
    sortField: 'invoiceCount',
  },
  {
    id: 'paymentMethod',
    initialPercentWidth: 11,
    labelKey: 'finance_hub.customers.table.column.payment_method',
    minSize: PAYMENT_METHOD_COLUMN_MIN_WIDTH,
    sortField: 'paymentMethod',
  },
  {
    id: 'autopay',
    initialPercentWidth: 8,
    labelKey: 'finance_hub.customers.table.column.autopay',
    minSize: AUTOPAY_COLUMN_MIN_WIDTH,
    sortField: 'autopay',
  },
  {
    id: 'paymentPlan',
    initialPercentWidth: 10,
    labelKey: 'finance_hub.customers.table.column.payment_plan',
    minSize: PAYMENT_PLAN_COLUMN_MIN_WIDTH,
    sortField: 'paymentPlan',
  },
  {
    id: 'statement',
    initialPercentWidth: 9,
    labelKey: 'finance_hub.customers.table.column.statement',
    minSize: STATEMENT_COLUMN_MIN_WIDTH,
    sortField: 'statement',
  },
  {
    id: 'contactInfo',
    initialPercentWidth: 8,
    labelKey: 'finance_hub.customers.table.column.contact_info',
    minSize: CONTACT_INFO_COLUMN_MIN_WIDTH,
    sortField: 'contactInfo',
  },
];

export const CUSTOMERS_TABLE_ROW_HEIGHT = 68;
